import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: {
        title: 'Sign Up',
      },
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: () => import('../views/ConfirmView.vue'),
      meta: {
        title: 'Confirm Sign Up',
      },
    },
    {
      path: '/confirmed',
      name: 'confirmed',
      component: () => import('../views/ConfirmedView.vue'),
      meta: {
        title: 'Confirmed Swiftaid Reauthorisation',
      },
    },
    {
      path: '/:catchAll(.*)',
      redirect: '/',
    },
  ],
})

router.afterEach((to) => {
  if (document === null) return

  const DEFAULT_TITLE = 'Swiftaid Donors'
  const DEFAULT_DESCRIPTION =
    'Help causes you donate to claim Gift Aid by signing up with Swiftaid for free!'

  let title = DEFAULT_TITLE
  if (to.meta.title) {
    title = `${to.meta.title} | ${DEFAULT_TITLE}`
  }
  document.title = title
  document
    ?.querySelector('meta[property="og:title"]')
    ?.setAttribute('content', title)
  document
    ?.querySelector('meta[name="twitter:title"]')
    ?.setAttribute('content', title)

  let description: string = DEFAULT_DESCRIPTION
  if (to.meta.description) {
    description = `${to.meta.description}`
  }
  document
    ?.querySelector('meta[name="description"]')
    ?.setAttribute('content', description)
  document
    ?.querySelector('meta[property="og:description"]')
    ?.setAttribute('content', description)
  document
    ?.querySelector('meta[name="twitter:description"]')
    ?.setAttribute('content', description)
})

export default router
